<table class="table table-borderless mb-0 text-center">
  <thead>
    <tr>
      <th class="fw-medium">
        <span class="z-dot nb-dot nb-detractor" aria-hidden="true"></span>Detractor
      </th>
      <th class="fw-medium">
        <span class="z-dot nb-dot nb-pasivo" aria-hidden="true"></span>Pasivo
      </th>
      <th class="fw-medium">
        <span class="z-dot nb-dot nb-promotor" aria-hidden="true"></span>Promotor
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="fw-bold">{{ summary.detractor }}%</td>
      <td class="fw-bold">{{ summary.pasivo }}%</td>
      <td class="fw-bold">{{ summary.promotor }}%</td>
    </tr>
    @if (withBars) {
      <tr class="nb-bars">
        <td>
          <div class="z-mini-bar">
            <span class="nb-bar nb-detractor" [style.width.%]="summary.detractor"></span>
          </div>
        </td>
        <td>
          <div class="z-mini-bar">
            <span class="nb-bar nb-pasivo" [style.width.%]="summary.pasivo"></span>
          </div>
        </td>
        <td>
          <div class="z-mini-bar">
            <span class="nb-bar nb-promotor" [style.width.%]="summary.promotor"></span>
          </div>
        </td>
      </tr>
    }
  </tbody>
</table>
